/**
 * Exchange uses ErrorItemNotFound for both missing items and missing folders.
 * We tell them apart by the message: if the folder we asked to move to appears
 * in it, the mailbox is missing that folder.
 *
 * The folder identifier is the one we sent (`junkemail`, `deleteditems`) and is
 * culture-invariant, so this holds for a mailbox in any language - see #324.
 */
export const isMissingFolderMessage = (message?: unknown, destinationFolderId?: string): boolean =>
  typeof message === 'string' &&
  !!destinationFolderId &&
  message.toLowerCase().includes(destinationFolderId.toLowerCase());
